function toggleAccordion(element) {
  const content = element.nextElementSibling;
  const isActive = content.classList.contains("active");
  document.querySelectorAll(".ag-accordion-content").forEach((item) => {
    item.classList.remove("active");
  });
  document.querySelectorAll(".ag-accordion-title").forEach((item) => {
    item.classList.remove("active");
  });
  if (!isActive) {
    content.classList.add("active");
    element.classList.add("active");
  }
}